/**
 * PageInfo — a page's explanation behind a small ⓘ beside its title (owner UI-INFO-1: no explanatory paragraphs on
 * the page). The text is shown on hover, focus or tap; the button is named for screen readers.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Button, Tooltip } from 'antd';
import { Info } from 'lucide-react';

export default function PageInfo({ text, label = 'About this page', style }) {
  if (!text) return null;
  return (
    <Tooltip title={text} trigger={['hover', 'focus', 'click']} placement="bottomLeft">
      <Button type="text" size="small" shape="circle" aria-label={label} style={style} icon={<Info size={16} aria-hidden="true" />} />
    </Tooltip>
  );
}

PageInfo.propTypes = { text: PropTypes.node, label: PropTypes.string, style: PropTypes.object };
